import React, { Component } from 'react';
import { compose } from 'recompose';
import queryString from 'query-string';
import config from '../../../config';
import { HTMLTrans, localeMinimalRedux } from '../../Common/Translations';
import { localiseAmount, roundCurrency } from '../../Common/Helper';
import ViewMorePagination from '../../Common/ViewMorePagination';

class Credit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      transactionsList: [],
      lastPage: 1,
      currentPage: 1,
      perPage: 5,
    };
    this.shouldCallApi = this.shouldShowFaq = window.location.pathname.includes('credit');
    this.didCallApi = false;
    this.getTransactions = this.getTransactions.bind(this);
    this.callApiOnLoad = this.callApiOnLoad.bind(this);
    this.renderLineItem = this.renderLineItem.bind(this);
  }

  callApiOnLoad() {
    this.shouldCallApi = this.shouldShowFaq = window.location.pathname.includes('credit');
    if(this.shouldCallApi && !this.didCallApi) {
      this.didCallApi = true;
      this.getTransactions();
    }
  }

  formatAmount(amount, currency) {
    return `${currency} ${localiseAmount(roundCurrency(amount))}`;
  }

  componentDidMount() {
    this.callApiOnLoad();
  }

  componentDidUpdate() {
    this.callApiOnLoad();
  }

  getTransactions(pageNum = 1) {
    const params = queryString.stringify({
      page: pageNum,
      perPage: this.state.perPage
    });

    $.get(`${config.localeApi}/shipping_credit_transactions?${params}`)
    .done((response) => {
      if (response.data) {
        this.setState((prevState) => ({
          transactionsList: prevState.transactionsList.concat(response.data.transactions),
          lastPage: response.data.pagination.last_page || 1,
          currentPage: response.data.pagination.current_page || 1,
          perPage:response.data.pagination.per_page || 5,
        }));
      }
    }).fail(() => {
      this.setState({
        transactionsList: []
      });
    });
  }

  renderLineItem(item, key) {
    const dateOptions = {
      year: 'numeric',
      month:'short',
      day: 'numeric'
    };
    const itemDate = new Date(item.date).toLocaleDateString('en-MY', dateOptions);
    const isPositive = item.status == 'credit';
    const signedAmount = [(isPositive ? '+' : '-'), this.props.shippingCreditCurrency, item.amount].join(' ');
    const isLast = key == (this.state.transactionsList.length - 1)

    return (<div key={"transaction"+key}>
      <div className="row transaction-line-item">
        <div className="col-3">{itemDate}</div>
        <div className="col-6">{item.name}</div>
        <div className={`col-3 credit-float-right ${ isPositive ? 'credit-transaction-positive' : '' }`}>{signedAmount}</div>
      </div>
      {isLast ? <br/> : <hr/> }
    </div>
    );
  }

  render() {
    const lang = this.props.lang;
    const {
      storeCreditCurrency,
      storeCreditBalance,
      shippingCreditCurrency,
      shippingCreditBalance,
      shippingCreditNearestExpiry,
      creditFaqUrl = `/${lang}/credit-faq`,
    } = this.props;

    let shippingCreditNearestExpiryDiv = null;

    if (shippingCreditNearestExpiry) {
      const expiryAmount = this.formatAmount(shippingCreditNearestExpiry.amount, shippingCreditCurrency);
      const expiryDate = shippingCreditNearestExpiry.date.split(' ')[0].split('-').reverse().join('-');

      shippingCreditNearestExpiryDiv = (
        <div className="mb-2">
          <span className="shipping-credit-expiry-modal-trigger" data-toggle="modal" data-target="#shipping-credit-expiry-modal">
            <HTMLTrans id="account.credit_credit_expiryinfo" variables={{amount: expiryAmount, date: expiryDate}}>
              {expiryAmount} credit will expire on {expiryDate}
            </HTMLTrans>
            <i className="shipping-credit-expiry-modal-trigger__icon ml-1 fa fa-question-circle" aria-hidden="true"></i>
          </span>
        </div>
      );
    }

    return (
      <div className='dashboard-card p-3 p-lg-5'>
        <h3><HTMLTrans id="account.credit_credit_heading">My Credits</HTMLTrans></h3>
        <hr />

        <div className="d-md-flex justify-content-between">
          <div>
            <div className="h4 font-weight-bold"><HTMLTrans id="account.credit_credit_storecreditbalance">Store Credit Balance</HTMLTrans></div>
          </div>
          <div>
            <div className="h4 font-weight-bold">{this.formatAmount(storeCreditBalance, storeCreditCurrency)}</div>
          </div>
        </div>

        <hr />

        <div className="d-md-flex justify-content-between">
          <div>
            <div className="h4 font-weight-bold"><HTMLTrans id="account.credit_credit_shippingcreditbalance">Shipping Credit Balance</HTMLTrans></div>
            {shippingCreditNearestExpiryDiv}
          </div>
          <div>
            <div className="h4 font-weight-bold">{this.formatAmount(shippingCreditBalance, shippingCreditCurrency)}</div>
          </div>
        </div>

        {this.state.transactionsList.length > 0  && <div>
          <br/>
          <h6><b><HTMLTrans id="account.recent_transaction">Recent transaction</HTMLTrans></b></h6>
          {this.state.transactionsList.map(this.renderLineItem)}
          <ViewMorePagination
            lastPageNumber={this.state.lastPage}
            currentPageNumber={this.state.currentPage}
            pageNumberPerPage={this.state.perPage}
            onClick={this.getTransactions}
            viewMoreMessageKey='account.view_more_transaction'
            viewMoreDefaultMessage='View more transaction history'
            className="credit-float-right"
          />
        </div>}

        <hr />

        {this.shouldShowFaq && <div>
          <iframe className="credit-page__iframe" src={creditFaqUrl} />
        </div>}
      </div>
    );
  }
}

const enhance = compose(
  localeMinimalRedux,
)

export default enhance(Credit);
export const undecorated = Credit;


// WEBPACK FOOTER //
// ./src/Account/Credit/Credit.js